import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useCollection } from 'Context/CollectionContext';
import DataContainer from 'Components/UI/DataContainer';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';

import { TrustApprovalOverride } from 'Resources/TrustApproval';

const styles = () => ({
  root: {},
  header: {},
  hidden: {
    display: 'none',
  },
  actions: {
    gap: '16px',
    display: 'flex',
  },
});

const AdditionalTrusteeForm = ({
  onSubmit,
  index,
}) => {
  const {
    collection,
    isInitializing,
    initializingError,
  } = useCollection();

  const resource = React.useMemo(() => {
    if (!collection) return null;
    if (index !== null) {
      return collection?.resources().index(index);
    }
    return collection.create();
  }, [collection !== null, index]);

  return (
    <DataContainer loading={isInitializing || !collection} loadingError={initializingError}>
      {resource && <MetaFormInline
        onDelete={resource.id() ? onSubmit : null}
        resource={resource}
        onSubmit={onSubmit}
        metaOverrideSet={TrustApprovalOverride}
      />}
    </DataContainer>
  );
};

AdditionalTrusteeForm.defaultProps = {
  index: null,
};

AdditionalTrusteeForm.propTypes = {
  index: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
};

export default withStyles(styles)(AdditionalTrusteeForm);
